<template>
  <div>
    <el-cascader style="width: 200px;"
                 :options="groups" v-model="tableQuery.formId"
                 :props="{value: 'id',label: 'name',children: 'children'}"
                 collapse-tags placeholder="请选择表单类型"
                 clearable></el-cascader>
    <el-select clearable
               v-model="tableQuery.createId" style="width: 180px;margin:0 10px"
               filterable placeholder="请选择发起人" :loading="coachLoading"
               remote reserve-keyword :remote-method="selectCoach">
      <el-option v-for="(coach,index) in coachList" :key="index" :label="coach.name" :value="coach.id">
        {{ coach.id }} - {{ coach.name }}
      </el-option>
    </el-select>
    <el-select v-model="tableQuery.status" clearable placeholder="请选择状态" style="width: 130px">
      <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"/>
    </el-select>
    <el-date-picker style="margin:0 10px"
                    v-model="tableQuery.applyDate"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
    </el-date-picker>
    <el-button :loading="tableQuery.loading" type="danger" @click="selectPage">搜 索</el-button>
    <el-button type="danger" icon="el-icon-upload2" @click="uploadDialog = true">导 入</el-button>
    <el-button type="danger" icon="el-icon-download" @click="exportFile">导 出</el-button>
    <el-button type="danger" icon="el-icon-delete" :disabled="selection.length === 0" :loading="batchDeleteLoading"
               @click="handleBatchDelete">批量删除{{ selection.length ? `(${selection.length})` : '' }}</el-button>
    <el-table border class="table" height="610px"  :cell-style="{padding:0+'px'}"
              :data="tableData"
              ref="table"
              v-loading="tableQuery.loading"
              :element-loading-text="loadingText"
              stripe
              @selection-change="handleSelectionChange"
              @row-dblclick="handleRowDbClick"
    >
      <el-table-column type="selection" width="50" align="center"/>
      <el-table-column
          prop="processDefinitionName"
          label="申请表单"
          width="200"
      >
        <template slot-scope="scope">
          <div style="word-break: break-all"><span>{{ scope.row.processDefinitionName }}</span>
            <!-- 批量导入的数据：跟在表单名右上角，悬停显示导入人 -->
            <el-tooltip v-if="scope.row.importName" effect="dark"
                        :content="scope.row.importName + '老师，导入的申请单！'" placement="top">
              <i class="el-icon-upload2"
                 style="position: relative;top: -6px;margin-left: 4px;color: #409EFF;font-size: 14px;font-weight: bold;cursor: pointer"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="170" property="coachName" label="发起人">
        <template #default="coach">
          <div style="display: flex; align-items: center;">
            <!-- 图片容器：增加相对定位，作为性别图标的定位基准 -->
            <div style="position: relative; margin: 10px 10px 2px 0;">
              <el-image
                  style="width: 35px; height: 35px; border-radius: 6px;"
                  :src="coach.row.startUser.portrait"
                  :preview-src-list="[coach.row.startUser.portrait]"
              >
                <div slot="error" class="image-slot" style="display: flex; justify-content: center;">
                  <span class="el-icon-picture-outline" style="margin-top: 10px"></span>
                </div>
              </el-image>
              <!-- 性别图标：绝对定位到图片右上角 -->
              <div v-if="coach.row.startUser.sex === 0" style="color: #F56C6C;" class="el-icon-female sex"></div>
              <div v-if="coach.row.startUser.sex === 1" style="color: #409EFF;" class="el-icon-male sex"></div>
            </div>
            <div>{{ coach.row.startUser.name | truncate }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="businessStatus" label="申请状态" align="center" width="110">
        <template slot-scope="scope">
          <el-tag size="small" :type="businessStatusInfo(scope.row.businessStatus).type">
            {{ businessStatusInfo(scope.row.businessStatus).text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="startTime"
          label="提交时间"
          :formatter="formatTime"
      />
      <el-table-column
          prop="endTime"
          label="结束时间"
          :formatter="formatTime"
      />
      <el-table-column
          prop="currentActivityName"
          label="当前节点"
      />
      <el-table-column prop="duration" label="已耗时" width="200"/>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button size="mini" style="margin-right: 10px" type="primary" @click="handleRowDbClick(scope.row)">查看
          </el-button>
          <el-popconfirm
              title="确定删除该申请吗？"
              icon="el-icon-warning"
              icon-color="#f56c6c"
              confirm-button-text="确定"
              cancel-button-text="取消"
              @confirm="handleDelete(scope.row)"
          >
            <el-button slot="reference" size="mini" icon="el-icon-delete" circle type="danger"></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right; margin-top: 20px;"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40, 50]"
        :current-page.sync="tableQuery.pageNo"
        @current-change="selectPage"
        @size-change="handleSizeChange"
        :page-size="tableQuery.pageSize"
        :total="total"
    />
    <el-dialog
        title="导入申请"
        :visible.sync="uploadDialog"
        width="800px"
        @close="resetUpload">
      <div v-loading="uploadLoading" element-loading-text="导入中..."
           style="display: flex;justify-content: center;height: 300px;align-items: center">
        <div>
          <el-cascader style="width: 200px;"
                       :options="groups" v-model="uploadQuery.formId"
                       :props="{value: 'id',label: 'name',children: 'children'}"
                       collapse-tags placeholder="请选择表单类型"
          ></el-cascader>
          <div class="flex" style="margin: 10px 0">
            <el-tooltip class="item" effect="dark" content="单次批量导入最大1000行数据！" placement="top">
              <div class="set-button">
                您要批量导入<input class="import-row" type="text" maxlength="4" @input="numberVerify" @blur="numberVerify"
                             v-model="uploadQuery.importRow"/>行
              </div>
            </el-tooltip>
            <el-button type="danger" :loading="templateLoading" :disabled="!canDownloadTemplate" @click="downloadTemplate">
              下载模板
            </el-button>
          </div>
          <el-upload :auto-upload="false" action=" " drag :limit="1" :on-change="changeFile"
                     :file-list="uploadFileList">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </div>
      </div>
      <div style="text-align: right; margin: 40px 20px 10px 0">
        <el-button @click="uploadDialog = false">取 消</el-button>
        <el-button type="danger" :loading="uploadLoading" @click="importFile">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  allApplyList,
  getFormGroups,
  exportApplyList,
  deleteApply,
  importApplyExcel,
  downloadImportTemplate
} from "@/api/oa/pages";
import {formatTime, formatBusinessStatus, selectBusinessStatusList, businessStatusInfo} from "../form";
import {selectCoach} from "../../../api/contacts/user";
import {downloadALink} from "@/utils/fileUtils";
import {Notification} from "element-ui";

export default {
  data() {
    return {
      total: 0,
      tableData: [],
      // 表格勾选的行（批量删除用）
      selection: [],
      batchDeleteLoading: false,
      // 表格 loading 文案：查询/删除/导入 分别不同
      loadingText: '请稍等...',
      groups: [],
      statusList: [],
      coachList: [],
      coachLoading: false,
      uploadDialog: false,
      uploadLoading: false,
      templateLoading: false,
      // 批量导入行数上限
      maxImportRow: 1000,
      uploadFileList: [],
      uploadQuery: {
        formId: [],
        file: null,
        // 本次批量导入的行数（后端字段 rowCount），最大 maxImportRow
        importRow: null,
      },
      tableQuery: {
        name: "",
        applyDate: null,
        loading: false,
        pageNo: 1,
        pageSize: 10,
        formId: [],
        createId: null,
        status: null,
        currentUserInfo: {
          id: null
        }
      },
    };
  },
  computed: {
    // 级联返回的是 [分组, 表单] 路径，选到叶子才算选中了表单
    hasUploadForm() {
      return !!(this.uploadQuery.formId && this.uploadQuery.formId.length > 1);
    },
    // 表单类型 + 批量导入数量都填了，才能下载模板
    canDownloadTemplate() {
      return this.hasUploadForm && !!this.uploadQuery.importRow;
    }
  },
  methods: {
    // 切换每页条数：回到第一页重新查询
    handleSizeChange(size) {
      this.tableQuery.pageSize = size;
      this.tableQuery.pageNo = 1;
      this.selectPage();
    },
    formatTime,
    formatBusinessStatus,
    businessStatusInfo,
    /**
     * 当前选中的表单 id（级联路径的最后一级）
     */
    currentUploadFormId() {
      const path = this.uploadQuery.formId || [];
      return path.length ? path[path.length - 1] : null;
    },
    /**
     * 当前选中的表单名称，用于兜底文件命名
     */
    currentUploadFormName() {
      const formId = this.currentUploadFormId();
      for (const group of this.groups) {
        for (const form of group.children || []) {
          if (form.id === formId) {
            return form.name || '导入模板';
          }
        }
      }
      return '导入模板';
    },
    selectPage() {
      this.loadingText = '请稍等...';
      this.tableQuery.loading = true;
      allApplyList(this.tableQuery).then((rsp) => {
        this.tableData = rsp.data.result.records;
        this.total = rsp.data.result.total;
      }).finally(() => {
        this.tableQuery.loading = false;
        // 数据刷新后清空勾选，避免残留已不存在的数据
        this.selection = [];
        this.$nextTick(() => {
          this.$refs.table && this.$refs.table.clearSelection();
        });
      });
    },
    importFile() {
      // 批量导入只校验文件：表单类型 / 批量导入数量只在「下载模板」时必填
      if (!this.uploadQuery.file) {
        this.$message.warning('请选择文件');
        return;
      }
      this.uploadLoading = true;
      const formData = new FormData();
      formData.append('file', this.uploadQuery.file);
      importApplyExcel(formData).then(res => {
        console.log(res)
        if (res.status == 200){
          if (res.data.code == 500) {
            Notification.error({title: "提醒", message: res.data.message, offset: 40,duration: 0});
          }else {
            this.uploadDialog = false;
            this.resetUpload();
            this.$notify({message: '导入成功！', title: '提醒', type: 'success', offset: 40});
            // 清空搜索条件后再查询，保证刚导入的数据能被看到
            this.resetQuery();
            this.selectPage();
          }
        }else {
          Notification.error({title: "提醒", message: res.data.message, offset: 40,duration: 0});
        }
      }).finally(() => {
        this.uploadLoading = false;
      });
    },
    changeFile(file) {
      this.uploadQuery.file = file.raw;
    },
    /**
     * 「您要批量导入 N 行」：只允许输入数字，且最大 5000
     */
    numberVerify(e) {
      let val = e.target.value;
      // 1. 不是数字 → null
      if (val === '' || isNaN(Number(val))) {
        this.uploadQuery.importRow = null;
      } else {
        let num = Number(val);
        // 大于上限 → 取上限；小于1 → 1
        if (num > this.maxImportRow) {
          this.uploadQuery.importRow = this.maxImportRow;
        } else if (num < 1) {
          this.uploadQuery.importRow = 1;
        } else {
          this.uploadQuery.importRow = num;
        }
      }
    },
    resetUpload() {
      this.uploadQuery.file = null;
      this.uploadFileList = [];
    },
    /**
     * 清空列表搜索条件（表单类型 / 发起人 / 状态 / 时间范围），并回到第一页
     */
    resetQuery() {
      this.tableQuery.formId = [];
      this.tableQuery.createId = null;
      this.tableQuery.status = null;
      this.tableQuery.applyDate = null;
      this.tableQuery.pageNo = 1;
    },
    /**
     * 下载导入模板：后端返回 JSON，result 是模板文件地址，直接下载
     */
    downloadTemplate() {
      if (!this.canDownloadTemplate) {
        this.$message.warning('请先选择表单类型并填写批量导入数量');
        return;
      }
      this.templateLoading = true;
      downloadImportTemplate({
        // 后端接收 List<String> formId，直接传级联的整条路径，不用取最后一级
        formId: this.uploadQuery.formId,
        // 批量导入行数：生成模板时同样要带上（后端用不到会忽略）
        rowCount: this.uploadQuery.importRow,
        currentUserInfo: this.tableQuery.currentUserInfo
      }).then((rsp) => {
        const data = rsp.data || {};
        if (data.success === false) {
          this.$message.warning(data.message || '模板下载失败，请稍后重试');
          return;
        }
        const url = data.result || data.data;
        if (url) {
          downloadALink(url, `${this.currentUploadFormName()}_导入模板.xlsx`);
        } else {
          this.$message.warning(data.message || '模板下载失败，请稍后重试');
        }
      }).catch((err) => {
        const msg = (err && err.response && err.response.data && err.response.data.message)
            || (err && err.message)
            || '模板下载失败，请稍后重试';
        this.$message.warning(msg);
      }).finally(() => {
        this.templateLoading = false;
      });
    },
    exportFile() {
      // 导出必选表单，未选到具体表单直接拦截
      if (!this.tableQuery.formId || this.tableQuery.formId.length < 2) {
        this.$message.warning('请选择导出表单');
        return;
      }
      this.loadingText = '导出中...';
      this.tableQuery.loading = true;
      exportApplyList(this.tableQuery).then((rsp) => {
        const data = rsp.data || {};
        if (data.success === false) {
          this.$message.warning(data.message || '导出失败，请稍后重试');
          return;
        }
        const url = data.result || data.data;
        if (url) {
          downloadALink(url, '审批数据.xlsx');
        } else {
          this.$message.warning(data.message || '导出失败，请稍后重试');
        }
      }).catch((err) => {
        const msg = (err && err.response && err.response.data && err.response.data.message)
            || (err && err.message)
            || '导出失败，请稍后重试';
        this.$message.warning(msg);
      }).finally(() => {
        this.tableQuery.loading = false;
      });
    },
    selectCoach(val) {
      this.coachLoading = true;
      selectCoach({coachName: val ? val : ''}).then(val => {
        this.coachLoading = false;
        this.coachList = val.data;
      })
    },
    handleRowDbClick(row) {
      this.$router.push({
        path: "/oa/form/instance/tabs",
        query: {
          processInstanceId: row.processInstanceId,
          type: "doneTask",
        },
      });
    },
    handleDelete(row) {
      this.loadingText = '删除中...';
      this.tableQuery.loading = true;
      deleteApply({processInstanceId: row.processInstanceId}).then((rsp) => {
        const data = rsp.data || {};
        if (data.success === false) {
          this.$message.warning(data.message || '删除失败，请稍后重试');
          return;
        }
        this.$notify.success({title: '提示', message: '删除成功！', offset: 40});
        // 删掉当前页最后一条时，自动回退一页
        if (this.tableData.length === 1 && this.tableQuery.pageNo > 1) {
          this.tableQuery.pageNo -= 1;
        }
        this.selectPage();
      }).catch((err) => {
        const msg = (err && err.response && err.response.data && err.response.data.message)
            || (err && err.message)
            || '删除失败，请稍后重试';
        this.$message.warning(msg);
      }).finally(() => {
        this.tableQuery.loading = false;
      });
    },
    // 表格勾选变化
    handleSelectionChange(rows) {
      this.selection = rows;
    },
    /**
     * 批量删除：传 processInstanceIds（单条删除走 handleDelete 的 processInstanceId）
     */
    handleBatchDelete() {
      if (!this.selection.length) return;
      const processInstanceIds = this.selection.map(item => item.processInstanceId);
      const count = processInstanceIds.length;
      this.$confirm(`确定删除选中的 ${count} 条申请吗？`, '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.batchDeleteLoading = true;
        // 表格也进入 loading，删除 + 刷新期间整表遮罩
        this.loadingText = '删除中...';
        this.tableQuery.loading = true;
        deleteApply({processInstanceIds}).then((rsp) => {
          const data = rsp.data || {};
          if (data.success === false) {
            this.tableQuery.loading = false;
            this.$message.warning(data.message || '删除失败，请稍后重试');
            return;
          }
          this.$notify.success({title: '提示', message: `已删除 ${count} 条申请！`, offset: 40});
          // 当前页被全部删完时，自动回退一页
          if (count >= this.tableData.length && this.tableQuery.pageNo > 1) {
            this.tableQuery.pageNo -= 1;
          }
          // 刷新列表（内部会把 tableQuery.loading 置 true → false）
          this.selectPage();
        }).catch((err) => {
          this.tableQuery.loading = false;
          const msg = (err && err.response && err.response.data && err.response.data.message)
              || (err && err.message)
              || '删除失败，请稍后重试';
          this.$message.warning(msg);
        }).finally(() => {
          this.batchDeleteLoading = false;
        });
      }).catch(() => {
        // 取消删除
      });
    },
  },
  mounted() {
    this.selectCoach();
    this.statusList = selectBusinessStatusList();
    const user = JSON.parse(localStorage.getItem("user"));
    this.tableQuery.currentUserInfo.id = user.id.toString();
    getFormGroups().then(rsp => {
      for (const item of rsp.data) {
        for (const form of item.children) {
          form.id = form.formId;
          form.name = form.formName;
        }
      }
      this.groups = rsp.data;
    })
    this.selectPage();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
  margin-top: 20px;
}

.set-button {
  margin-right: 10px;
  background-color: white;
  width: 175px;
  border: #d8dbe2 1px solid;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  color: #606266;
  text-align: left;
  display: flex;
  align-items: center;
}

.set-button:hover {
  border: #ff4d4f 1px solid;
  display: flex;
  align-items: center;
}

.import-row {
  border: none;
  border-bottom: solid 1px #ff4d4f;
  height: 20px;
  width: 50px;
  text-align: center;
  color: #ff4d4f;
}
</style>
